import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Location } from '../state-man/models/location.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getAll () : Promise<Location[] | null> {      
    try {
      const ret = await await this.apiService.apiReturnsAny('get', 'location/active/')         
      return (ret && Array.isArray(ret)) ? Location.buildMany(ret) : null
    } 
    catch (error) {     
      LoggerService.log(error + 'location/active/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')     
      return null
    }
  }  
  
}
